import { useMutation } from '@tanstack/react-query';

import { PluginEquifaxPpsrRegistrationRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runEquifaxPpsrRegistrationRequest } from '../../requests/runEquifaxPpsrRegistrationRequest';

export const useRunEquifaxPpsrRegistrationRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginEquifaxPpsrRegistrationRequest) =>
      runEquifaxPpsrRegistrationRequest(constructPost, data),
    onSuccess: () => handleSuccess('Equifax request completed'),
    onError: () => handleError('Equifax request failed'),
  });
  return { runEquifaxPpsrRegistrationRequest: mutateAsync, ...rest };
};
